import { AxiosInstance, AxiosPromise, AxiosRequestConfig } from 'axios';
import HttpClient from 'src/services/api-client/resource/base/HttpClient';
import { logout } from 'src/actions/authentication/login/Login.actions';
import { store } from 'src/store';
import AuthenticationService from 'src/services/authentication/Authentication';

export type Params = {};
export type Data = {};

class Resource {
  protected readonly route: string;
  protected readonly httpClient: AxiosInstance;
  protected readonly authentication: AuthenticationService;

  constructor(route: string) {

    this.httpClient = HttpClient;
    this.route = route;
    this.authentication = new AuthenticationService();
  }

  public get(id: number | string, params?: Params): AxiosPromise {
    this.getHeaders();

    let url: string;
    if (this.route.indexOf(':id') !== -1) {
      url = this.route.replace('/:id/', '/' + id + '/');
    } else {
      url = this.route + id;
    }

    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf('/:' + key + '/') !== -1) {
          url = url.replace('/:' + key + '/', '/' + params[key] + '/');
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig: AxiosRequestConfig = {
      params: queryParams,
    };

    return this.httpClient
      .get(url, requestConfig)
      .catch((errorResponse) => {
        if (errorResponse.response.status === 401) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  public index(params?: Params): AxiosPromise {
    this.getHeaders();

    let url: string = this.route;
    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf('/:' + key + '/') !== -1) {
          url = url.replace('/:' + key + '/', '/' + params[key] + '/');
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig: AxiosRequestConfig = {
      params: queryParams,
    };

    return this.httpClient
      .get(url, requestConfig)
      .catch((errorResponse) => {
        if (errorResponse.response.status === 401) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  public create(data: Data, params?: Params): AxiosPromise {
    this.getHeaders();

    let url: string = this.route;
    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf('/:' + key + '/') !== -1) {
          url = url.replace('/:' + key + '/', '/' + params[key] + '/');
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig: AxiosRequestConfig = {
      params: queryParams,
    };

    return this.httpClient
      .post(url, data, requestConfig)
      .catch((errorResponse) => {
        if (!url.includes('login') && errorResponse.response.status === 401) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  public update(id: number | string, data: Data, params?: Params): AxiosPromise {
    this.getHeaders();

    let url: string;
    if (this.route.indexOf(':id') !== -1) {
      url = this.route.replace('/:id/', '/' + id + '/');
    } else {
      url = this.route + id;
    }
    let queryParams = {};

    if (params) {
      Object.keys(params).forEach(key => {
        if (this.route.indexOf('/:' + key + '/') !== -1) {
          url = url.replace('/:' + key + '/', '/' + params[key] + '/');
        } else {
          queryParams[key] = params[key];
        }
      });
    }

    const requestConfig: AxiosRequestConfig = {
      params: queryParams,
    };

    return this.httpClient
      .put(url, data, requestConfig)
      .catch((errorResponse) => {
        if (errorResponse.response.status === 401) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  public destroy(id: string): AxiosPromise {
    this.getHeaders();

    const url: string = this.route + id;

    return this.httpClient
      .delete(url)
      .catch((errorResponse) => {
        if (errorResponse.response.status === 401) {
          store.dispatch(logout());
        }
        throw errorResponse;
      });
  }

  protected getHeaders(): void {
    const token = this.authentication.getToken();
    if (token) {
      this.httpClient.defaults.headers.common['X-Access-Token'] = 'Bearer ' + token.value;
    }
  }
}

export default Resource;


// WEBPACK FOOTER //
// ./src/services/api-client/resource/base/Resource.tsx